import { forkJoin } from 'rxjs';
import { CompetenceModel } from './../../../../../../../core/src/lib/models/competence.model';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { OnlinetestModel } from 'projects/core/src/lib/models/onlinetest.model';
import { BaseDetail } from 'projects/admin/src/app/classes/base-detail';
import { TranslocoService } from '@ngneat/transloco';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { DetailModes } from 'projects/admin/src/app/shared/constants';
import { HelperService } from 'projects/admin/src/app/services/helper.service';

@Component({
  selector: 'app-onlinetest-detail',
  templateUrl: './onlinetest-detail.component.html',
  styleUrls: ['./onlinetest-detail.component.scss']
})
export class OnlinetestDetailComponent extends BaseDetail implements OnInit {

  public partnerId: number = null;
  public onlinetest: OnlinetestModel = null;
  public competences: Array<CompetenceModel> = [];
  public backRoute = ['/partners'];

  constructor(
    protected ui: UiService,
    protected router: Router,
    protected helper: HelperService,
    protected transloco: TranslocoService,
    private api: ApiService,
    private route: ActivatedRoute
  ) {
    super(ui, router, helper, transloco);
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params.id > 0 && params.onlinetest > 0) {
        this.partnerId = params.id;
        this.backRoute = ['/partners', this.partnerId.toString()];
        this.setLoading();
        forkJoin([
          this.api.getModel('onlinetests', params.onlinetest),
          this.api.getModels('competences')
        ]).subscribe({
          next: (result: Array<any>) => {
            this.onlinetest = new OnlinetestModel().deserialize(result[0].data);
            if (result[1] !== null && result[1].data.length > 0) {
              result[1].data.forEach((competence: any) => {
                this.competences.push(new CompetenceModel().deserialize(competence));
              });
            }
            this.setInitialized(DetailModes.edit);
          },
          error: (error: any) => {
            this.setFailed(error);
          }
        });
      } else {
        this.onClose();
      }
    });
  }

}
